export function decorateLinkBox(data, typeName, timelineEntry) {
    const container = $(".timeline_entry#" + timelineEntry.id);
    container.find(".spinner").hide();
    container.find(".js-timeline-image").prepend("<a href='" + data.link + "' target='_blank'><img src=\"" + data.image + "\"/></a>");
    container.find(".js-link-preview-text").html(data.text);
}
